

import Vue from 'vue';
import apis from "../../apis";
import { getCookie, unionFlag } from '../index';

export default class Union {
  constructor() {
    this.unionCode = unionFlag() || sessionStorage.getItem('dffl_union');

    this.init();
  }

  init() {
    window.union_scale = 1;
    Vue.prototype.union_scale = 1;
    Vue.prototype.union_icon = '';
    Vue.prototype.union_name = '福豆';

    window.ms_url =
      window.location.protocol +
      '//' +
      window.location.host.replace('corp.', '') +
      '/ms/' +
      window.location.search +
      '&returnUrl=' +
      encodeURIComponent(window.df_sdk_common.location.href);


    if (this.unionCode && this.unionCode === 'null') {
      sessionStorage.setItem('dffl_union', this.unionCode);
    } else if (!this.unionCode) {
      sessionStorage.removeItem('dffl_union');
    }

  }

  // 工会转换比例
  setUnionScale() {
    apis.home.getBili().then((res) => {
      Vue.prototype.union_scale = res.body.scale || 1;
      Vue.prototype.union_icon = res.body.icon;
      Vue.prototype.union_name = res.body.name || '福豆';

      window.union_scale = res.body.scale;
      window.union_icon = res.body.icon;
      window.union_name = res.body.name || '福豆';
    })
  }

  // 获取中英文标识
  findByUnion() {
    const address = getCookie('address') || '{}'
    apis.headerApi.getFindByUnion({
      city: address ? JSON.parse(address).cityId : "",
      union: this.unionCode,
      Business: false
    }).then((res) => {
      const { mallUnionConfigDto = {} } = res.body;
      Vue.prototype.union_isBilingual = mallUnionConfigDto && mallUnionConfigDto.isBilingual;
    });
  }
}